import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AppFrontRoutes } from 'src/app/constants/app-front-routes';
import { GeneralService } from 'src/app/services/general.service';
import { PrivacyService } from "../../../../../services/privacy.service"

declare var $: any;

@Component({
  selector: 'app-treatment-register-create',
  templateUrl: './treatment-register-create.component.html',
  styleUrls: ['./treatment-register-create.component.css']
})
export class TreatmentRegisterCreateComponent implements OnInit {

  @Input() ID: string;
  @Input() lang: any;
  @Input() type: string;

  modalTitle: string;
  maintenance_plans: any;
  privacyTreatmentForm: FormGroup;
  privacyTreatmentFormSubmitted: Boolean = false;
  privacyTreatmentFormErrorMsg: any;
  record;
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private privacy:PrivacyService,
    private generalService: GeneralService,
  ) { }

  ngOnInit() {

    this.FormBuild()
    this.getData();

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: true,
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    this.modalTitle = (this.type == "Add")?this.lang.treatment_creation:this.lang.treatment_creation;
  }

  FormBuild(): void {
    
    this.privacyTreatmentForm = this.formBuilder.group({
      code: ['', [Validators.required]],
      description_treatment: ['', [Validators.required]],
      type: ['', [Validators.required]],
      tools_data_processing: ['', [Validators.required]],
      physical_location_data_storage: ['', [Validators.required]],
      type_access_to_computer_data: ['', [Validators.required]],
      physical_location: ['', [Validators.required]],
      type_access_to_paper_data: ['', [Validators.required]],
      treatment_creation_id: [''],
      id: '',
    });

  }

  FormBuildUpdate(): void {
    this.privacyTreatmentForm.patchValue({
      code:this.record.code,
      description_treatment:this.record.description_treatment,
      type:this.record.type,
      tools_data_processing:this.record.tools_data_processing,
      physical_location_data_storage:this.record.physical_location_data_storage,
      type_access_to_computer_data:this.record.type_access_to_computer_data,
      physical_location:this.record.physical_location,
      type_access_to_paper_data:this.record.type_access_to_paper_data,
      treatment_creation_id:this.ID
    })

  }

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }

  onSubmit() {
    this.privacyTreatmentFormSubmitted = true;

    if (this.privacyTreatmentForm.invalid)
      return;

    this.privacy.addTreatmentRegister(this.privacyTreatmentForm.value).subscribe(
      (resonse) => {
        this.generalService.notify_msg('success', resonse.msg);
        this.bsModalRef.hide();
        this.redirect()
      },
      (error) => {
        this.generalService.notify_msg('error', error);
        this.bsModalRef.hide();        

      }
    )

  }

  redirect() {
    this.router.navigateByUrl('/test', { skipLocationChange: true })
      .then(() => {
        this.router.navigate([AppFrontRoutes.PRIVACY_TREATMENT_REGISTER]);
      });
  }



  getData() {

    this.privacy.fetchSingleTreatmentRegister(this.ID).subscribe(
      (response) => {
        this.record = response.data.record;
        this.FormBuildUpdate()
        this.privacyTreatmentFormErrorMsg = {
          'code': [{ type: 'required', message: this.lang.requiredField }],
          'description_treatment': [{ type: 'required', message: this.lang.requiredField }],
          'type': [{ type: 'required', message: this.lang.requiredField }],
          'tools_data_processing': [{ type: 'required', message: this.lang.requiredField }],
          'physical_location_data_storage': [{ type: 'required', message: this.lang.requiredField }],
          'type_access_to_computer_data': [{ type: 'required', message: this.lang.requiredField }],
          'physical_location': [{ type: 'required', message: this.lang.requiredField }],
          'type_access_to_paper_data': [{ type: 'required', message: this.lang.requiredField }],
        }        

      },
      (error) => {

      }
    )    
    


  }

}
